import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import {
  Form, Input, Button,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import wrapReact from '../../../util/react';
import { msgCB } from '../../../util/fetch/msgFetch';
import { actUI } from '../../../redux/action/ui';
import { CB_STATUS } from '../../../util/fetch/cFetch';

const FormItem = Form.Item;

export class NewForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      intl, form, onSubmit, dispatch,
    } = this.props;
    const { formatMessage } = intl;
    const cb = (res) => {
      actUI(dispatch, { uiDevice: { uiForm: { loading: false } } });
      if (res.status === CB_STATUS.SUCCESS) {
        form.resetFields();
      }
      switch (res.status) {
        case CB_STATUS.EXIST:
          if (res.payload === 'SerialNumber') {
            form.setFields({
              serialNumber: {
                value: form.getFieldValue('serialNumber'),
                errors: [
                  new Error(
                    formatMessage({
                      id: 'Device.checkSN.exist',
                      defaultMessage: 'serial number already exists',
                    }),
                  ),
                ],
              },
            });
          } else {
            form.setFields({
              displayName: {
                value: form.getFieldValue('displayName'),
                errors: [
                  new Error(
                    formatMessage({
                      id: 'Device.checkDisplayName.exist',
                      defaultMessage: 'display name already exists',
                    }),
                  ),
                ],
              },
            });
          }
          break;
        case CB_STATUS.INVALID:
          form.setFields({
            serialNumber: {
              value: form.getFieldValue('serialNumber'),
              errors: [
                new Error(
                  formatMessage({
                    id: 'Device.checkSN.invalid',
                    defaultMessage: 'invalid serial number',
                  }),
                ),
              ],
            },
          });
          break;
        default:
          msgCB(res.status, formatMessage);
          break;
      }
    };
    form.validateFields((err, v) => {
      const values = v;
      if (!err) {
        if (form.getFieldValue('serialNumber').length === 7) {
          form.setFieldsValue({ serialNumber: `${form.getFieldValue('serialNumber')}` });
          values.serialNumber = `${values.serialNumber}`;
        }
        actUI(dispatch, { uiDevice: { uiForm: { loading: true } } });
        onSubmit(
          {
            SerialNumber: values.serialNumber,
            DisplayName: values.displayName,
          },
          cb,
        );
      }
    });
  };

  handleCancel = () => {
    const { form, onCancel } = this.props;
    form.resetFields();
    onCancel();
  };

  render() {
    const {
      intl, form, data, filePath, className, ui,
    } = this.props;
    const { formatMessage } = intl;
    const { getFieldDecorator } = form;

    return (
      <Form
        layout="horizontal"
        onSubmit={this.handleSubmit}
        className={`${filePath} ${className}`}
      >
        <FormItem
          label={formatMessage({
            id: 'Device.serialNumber',
            defaultMessage: 'serial number',
          })}
        >
          {getFieldDecorator('serialNumber', {
            initialValue: data && data.SerialNumber,
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: 'Device.serialNumberCheck',
                  defaultMessage: 'please input device serial number',
                }),
              },
              {
                max: 11,
                min: 7,
                message: formatMessage({
                  id: 'validator.deviceInvalidLength',
                  defaultMessage: 'length of input is not ok',
                }),
              },
              {
                pattern: /^[0-9]*$/,
                message: formatMessage({
                  id: 'validator.digital',
                  defaultMessage: 'only 0-9 are accepted',
                }),
              },
            ],
          })(<Input disabled={!!data} autoComplete="off" />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'Device.displayName',
            defaultMessage: 'display name',
          })}
        >
          {getFieldDecorator('displayName', {
            initialValue: data && data.DisplayName,
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: 'Device.displayNameCheck',
                  defaultMessage: 'please input display name',
                }),
              },
              {
                max: 20,
                min: 2,
                message: formatMessage({
                  id: 'validator.deviceNameinvalidLength',
                  defaultMessage: 'length of input is not ok',
                }),
              },
              {
                pattern: /^[A-Za-z0-9äöüÄÖÜß\s]+$/,
                message: formatMessage({
                  id: 'validator.noSpecialChar',
                  defaultMessage: 'only a-z, A-Z, 0-9 charaters are accepted',
                }),
              },
            ],
          })(<Input autoComplete="off" />)}
        </FormItem>
        <FormItem className="btn-area">
          <Button
            type="primary"
            onClick={this.handleCancel}
            className="form-bt"
          >
            <FormattedMessage id="app.btn.cancel" defaultMessage="cancel" />
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={ui.loading}
            className="form-bt"
          >
            <FormattedMessage id="app.btn.ok" defaultMessage="ok" />
          </Button>
        </FormItem>
      </Form>
    );
  }
}

NewForm.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    DisplayName: PropTypes.string.isRequired,
    SerialNumber: PropTypes.string.isRequired,
  }).isRequired,
  ui: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default Form.create()(wrapReact(NewForm, 'container_device_Form'));
